import { differenceInDays } from 'date-fns'
import { TFunction } from 'react-i18next'
import { getStatus } from '../../../../hooks/status'
import { actionPlansServices } from '../../../../service/actionPlans'
import { Constants } from '../../../../utils/constants'
import { httpFetch } from '../../../../utils/crud'
import { Color } from '../../../../utils/theme/types/color'
import dayjs from 'dayjs'

const getAll = async (t: TFunction<'translation', undefined>, colors: Color, body?: { queries?: string; reloadData?: boolean }) => {
  const data = await actionPlansServices(httpFetch).getAll(body)

  const row = !data.errors
    ? data?.items?.map((item) => {
      // const store = item?.store
      // const action_plan = item?.actionPlan
      // const generatedByOption = action_plan?.generatedByOption
      // const questionnaire = item?.assignedQuestionnaire?.questionnaireMain
      // const zoneFather = store?.storeZone
      // const zoneChild = store?.storeClass
      // const month = format(new Date(action_plan.startDate), 'LLLL', { locale: es })
      const create_time = item.startDate
      const finishDate = item.finishDate
      const user = item?.fullName
      const division = item.division
      const timeZone = item.codeTimezone ? item.codeTimezone ?? Constants.defaultTimeZone : undefined
      const formatCreate = create_time ? dayjs(create_time).tz(timeZone).locale('es').format(Constants.dayjsFormat4) : t('general.noData')
      const formatFinish = finishDate ?  dayjs(finishDate).tz(timeZone).locale('es').format(Constants.dayjsFormat4) : t('general.noData')
      const differenceDays = create_time && finishDate ? differenceInDays(new Date(create_time), new Date(finishDate)) : null


      return {
        id: item?.id,
        divisions: division,
        user: user,
        stores: item?.store,
        questionnaire: item.questionnaireName,
        isItem: item.byItem,
        dateRequestion: {
          label: formatCreate,
          value: create_time ? new Date(create_time).getTime() : 0,
          type: 'date',
        },
        deadline: {
          label: formatFinish,
          value: finishDate ? new Date(finishDate).getTime() : 0,
          type: 'date',
        },
        backlog: differenceDays !== null && differenceDays >= 0 ? differenceDays : t('general.noBacklog'),
        status: getStatus(item.statusId, colors, t),
        country: 'México',
        question: item?.detailCreation?.question,
        isByItem: !!item.detailCreation?.actionPlanByItem,
        answers: item.detailCreation?.answers,
        // section: generatedByOption?.question?.section?.title,
        // cve: user?.division?.cveDivision ? user?.division?.cveDivision : 'N/A',
        // month: month ? month.charAt(0).toUpperCase() + month.slice(1) : 'N/A',
        // idStore: store?.keyCode,
        // state: store?.zipCode?.state,
        // city: store?.zipCode?.country,
        // role: user?.role?.description,
        // userType: user?.userType?.name,
        // curp: user?.curp,
        // weekYear: 'Semana ' + getWeek(new Date(action_plan.startDate)),
        // year: getYear(new Date(action_plan.startDate)),
        // zones: zoneFather?.name,
        // reportUrl: action_plan?.reportUrl,
        // statusActionPlan: action_plan?.status?.description,
        // requestDate: action_plan?.create_time ? format(new Date(action_plan?.create_time), Constants.dateFormat) : null,
        // requestHour: action_plan?.create_time ? format(new Date(action_plan?.create_time), Constants.hourFormat) : null,
        // soloveDate: action_plan?.update_time && action_plan?.status?.id === Status.APPROVED ? format(new Date(action_plan?.update_time), Constants.dateFormat) : null,
        // soloveHour: action_plan?.update_time && action_plan?.status?.id === Status.APPROVED ? format(new Date(action_plan?.update_time), Constants.hourFormat) : null,
        // deadlineDate: action_plan?.finishDate ? format(new Date(action_plan?.finishDate), Constants.dateFormat) : null,
        // deadlineHour: action_plan?.finishDate ? format(new Date(action_plan?.finishDate), Constants.hourFormat) : null,
        // elapsedDays: action_plan?.elapsedDays,
        // elapsedHour: action_plan?.elapsedHours,
        // rejects: `${action_plan?.actionPlanAnswers?.filter((itemActionPlanAnswer) => itemActionPlanAnswer?.statusId === Status?.REJECTED)?.length ?? 0} / ${action_plan?.maxRejections}`,
        // division: store?.storesDivision?.[0]?.division?.description,
        // class: zoneChild?.name,
      }
    })
    : []
  return {
    row,
    totalPages: data.totalPages,
    totalItems: data.totalItems,
    currentPage: data.currentPage,
  }
}

const itemTypeActionPlan = ({ t }: { t: TFunction<'translation', undefined> }) => [
  {
    label: t('actionPlan.byStores'),
    value: true
  },
  {
    label: t('actionPlan.byUsers'),
    value: false
  }
]

export { getAll, itemTypeActionPlan }